<!--
 * @Author: ckj kaijun.cui@biz-united.com.cn
 * @Date: 2024-05-20 14:34:38
 * @LastEditors: ckj kaijun.cui@biz-united.com.cn
 * @LastEditTime: 2025-12-31 16:35:01
 * @Description:
-->
<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import { VXETable } from 'vxe-table';
import ImageViewer from '@/found/components/ImageViewer';

export default {
  extends: TablePage,
  components: {
    ImageViewer,
  },
  data() {
    return {
    };
  },
  mounted() {
    this.getConfigList('reconciliation_details_list');
  },
  created() {
    VXETable.renderer.add('AdsImage', {
      // 默认显示模板
      renderDefault(_h, _renderOpts, params) {
        const { row } = params;
        return [
          <ImageViewer
            src={row.backgroundIdCardPath}
            previewSrcList={row.backgroundIdCardPath}
            style='width: 40px; height: 40px'
            fit="cover">
          </ImageViewer>,
        ];
      },
    });
  },
  methods: {
    setColumn(col) {
      const rowData = col;
      // if (rowData.field === 'backgroundIdCardPath') {
      //   rowData.cellRender = { name: 'AdsImage' };
      // }
      if (rowData.field === 'payFileUrl') {
        rowData.type = 'html';
        rowData.formatter = ({ row }) => `${
          row.payFileUrl
            ? `<a href=${row.payFileUrl}>${row.payFileName}</a>`
            : ''
        }`;
      }
      return rowData;
    },
  },
};
</script>
